module.exports = __webpack_public_path__ + "img/TISCO.e7e1a245.png";